import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { revokeConfirmationFormId, revokeResult } from '../Enums';
import { useNavigate } from 'react-router-dom';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';

const RevokeConfirmationButtons = ({ closeView, revokeState, error }) => {
  const navigate = useNavigate();

  const navigateToSearchPage = () => {
    navigate('/');
  };

  const renderPrimaryButton = () => {
    if (error === null) {
      if (revokeState === revokeResult.removedWithTeam) {
        return <PrimaryButton text={formatMessage(Messages.common_goToSearch)} onClickEvent={navigateToSearchPage} />;
      }
      if (revokeState === revokeResult.undefined) {
        return (
          <Button
            size={ButtonSize.MEDIUM}
            type={ButtonType.FILLED}
            variant={ButtonVariant.DANGER}
            htmlType="submit"
            form={revokeConfirmationFormId}>
            {formatMessage(Messages.revokeConfirmation_yesRevoke)}
          </Button>
        );
      }
    }
    return null;
  };

  return (
    <>
      {revokeState !== revokeResult.removedWithTeam && (
        <SecondaryButton
          text={
            revokeState !== revokeResult.undefined
              ? formatMessage(Messages.common_close)
              : formatMessage(Messages.common_cancel)
          }
          onClickEvent={closeView}
        />
      )}

      {renderPrimaryButton()}
    </>
  );
};

export default RevokeConfirmationButtons;
